// extracted by mini-css-extract-plugin
export var billboardImage = "article-module--billboard-image--WBPvG";
export var wrapper = "article-module--wrapper--ZUvmY";